import type {
  GetCustomerHierarchyObject,
  GetCustomerHierarchyResponse,
} from "../api/Customers";

export const mapHierarchyArrayToObject = (
  baseObject: GetCustomerHierarchyResponse,
  hierarchy: GetCustomerHierarchyResponse[]
) => {
  const root: GetCustomerHierarchyObject = {
    ...baseObject,
    children: [],
  };

  if (root.childrenCount > 0) {
    hierarchy.forEach((child) => {
      if (child.parentId === baseObject.id) {
        root.children.push(mapHierarchyArrayToObject(child, hierarchy));
      }
    });
  }

  return root;
};
